import React from 'react';
import './App.scss';
import SharkTank from '../components/SharkTank';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <SharkTank />
      </div>
    );
  }
}

export default App;
